<div #radioHead width="100%" height="100%" gap=10 class="wiz-radio-head" [ngClass]="{'radio-focus-class': !wizDisabled, 'label-before ': isLabelBefore()}"
  (focus)="onFocus()" tabindex="-1">
  <label #innerLabelInput class="wiz-radio-container" height="22px" width="22px">
    <!-- input radiofdccc,  html véritable, masqué-->
    <input type="radio" class="inner-input" [value]="wizValue" [name]="wizGroupName" [(ngModel)]="wizGroupValue"
      [disabled]="getWizDisabled()" />
    <!-- Faux input CSS cablé sur le véritable -->
    <span class="wiz-radio" height="100%" width="22px" [ngClass]="{'error-class': hasErrors}"></span>
  </label>
  <wiz-spacer [width]="'5px'"></wiz-spacer>
  <wiz-label class="wiz-radio-label" #innerLabel [wizLabel]="wizLabel" (click)="selectMyValue()"
    [wizNbLine]=1 width="100%">
  </wiz-label>
</div>